


//POST CLINIC PROFILE 
export const POST_CLINICPROFILE_REQUEST = 'POST_CLINICPROFILE_REQUEST';
export const POST_CLINICPROFILE_SUCCESS = 'POST_CLINICPROFILE_SUCCESS';
export const POST_CLINICPROFILE_FAILURE = 'POST_CLINICPROFILE_FAILURE';

//GET CLINIC PROFILE 
export const GET_CLINICPROFILE_BY_ID_REQUEST = 'GET_CLINICPROFILE_BY_ID_REQUEST';
export const GET_CLINICPROFILE_BY_ID_SUCCESS = 'GET_CLINICPROFILE_BY_ID_SUCCESS';
export const GET_CLINICPROFILE_BY_ID_FAILURE = 'GET_CLINICPROFILE_BY_ID_FAILURE';
//POST DOCTOR PROFILE 
export const POST_DOCTORPROFILE_REQUEST = 'POST_DOCTORPROFILE_REQUEST';
export const POST_DOCTORPROFILE_SUCCESS = 'POST_DOCTORPROFILE_SUCCESS';
export const POST_DOCTORPROFILE_FAILURE = 'POST_DOCTORPROFILE_FAILURE';

//GET DOCTOR PROFILE BY ID
export const GET_DOCTORPROFILE_BY_ID_REQUEST = 'GET_DOCTORPROFILE_BY_ID_REQUEST';
export const GET_DOCTORPROFILE_BY_ID_SUCCESS = 'GET_DOCTORPROFILE_BY_ID_SUCCESS';
export const GET_DOCTORPROFILE_BY_ID_FAILURE = 'GET_DOCTORPROFILE_BY_ID_FAILURE';

//LOGIN
export const LOGIN = 'LOGIN';

//RESTORE SESSION
export const RESTORE_SESSION = 'RESTORE_SESSION';

//GET CLINIC
export const GET_CLINIC_REQUEST = 'GET_CLINIC_REQUEST';
export const GET_CLINIC_SUCCESS = 'GET_CLINIC_SUCCESS';
export const GET_CLINIC_FAILURE = 'GET_CLINIC_FAILURE';

//POST CUSTOM PATIENT FIELDS
export const POST_CUSTOM_PATIENT_FIELDS_REQUEST = 'POST_CUSTOM_PATIENT_FIELDS_REQUEST';
export const POST_CUSTOM_PATIENT_FIELDS_SUCCESS = 'POST_CUSTOM_PATIENT_FIELDS_SUCCESS';
export const POST_CUSTOM_PATIENT_FIELDS_FAILURE = 'POST_CUSTOM_PATIENT_FIELDS_FAILURE';